import React, { useEffect } from 'react'
import { oktaAuth } from '../../lib/okta-config'

const LoginAuth = () => {
  useEffect(() => {
    oktaAuth.signInWithRedirect().catch(error => {
      console.error('Okta redirect error', error)
    })
  }, [])

  return (
    <div className='df fxdrc jcc aic' style={{ minHeight: '100vh' }}>
      <p>Redirecting to Login ...</p>
    </div>
  )
}

export default LoginAuth
